import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, Switch, Redirect, withRouter } from "react-router-dom";
import Login from "./login/login";
import RecoverPassword from "./recoverPassword/recoverPassword";
import CaseSearch from "./caseSearch/caseSearch";
import CaseSummary from "./caseSummary/caseSummary";
import ClientDataCollect from "./clientDataCollect/clientDataCollect";
import * as routes from "./shared/routes";
import Navbar from "./components/navbar/Navbar";
import RecoverConfirmation from "./recoverConfirmation/recoverConfirmation";
import ResetPassword from "./resetPassword/resetPassword";
import SessionExpired from "./sessionExpired/sessionExpired";

class App extends Component {
  render() {
    let content = (
      <Switch>
        <Route path={routes.login} component={Login} />
        <Route path={routes.recoverPassword} component={RecoverPassword} />
        <Route path={routes.recoverConfirmation} component={RecoverConfirmation} />
        <Route path={routes.resetPassword} component={ResetPassword} />
        <Redirect to={routes.login} />
      </Switch>
    );

    if (this.props.token) {
      content = (
        <Switch>
          <Route path={routes.root} exact component={CaseSearch} />
          <Route path={routes.caseSearch} component={CaseSearch} />
          <Route path={routes.caseSummary} component={CaseSummary} />
          <Route path={routes.sessionExpired} exact component={SessionExpired} />
          <Route path={routes.login} exact component={Login} />
          <Route
            path={routes.clientDataCollect}
            component={ClientDataCollect}
          />
          <Redirect to={routes.caseSearch} />
        </Switch>
      );
    }

    return (
      <mosaic-page>
        <mosaic-notification id="notification-container" />
        <Navbar />
        {content}
      </mosaic-page>
    );
  }
}

const mapStateToProps = state => {
  return {
    token: state.login.token
  };
};

export default withRouter(connect(mapStateToProps)(App));
